import LightStateWidget from './component'

export default LightStateWidget
